import { render } from "./WarehouseInventory.vue?vue&type=template&id=30a27a62"
import script from "./WarehouseInventory.vue?vue&type=script&lang=js"
export * from "./WarehouseInventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__